<template>
  <div>
    <DefinePriceFilters>
      <div>
        <label for="price" class="block text-sm font-normal text-neutral pl-2">
          {{ $t('search.price') }}
        </label>
        <div class="grid grid-cols-2 gap-1.5 mb-1.5">
          <AppSelector
            id="price"
            ref="priceSelector"
            v-model="filters.priceFrom"
            class="variant-outline md:min-w-[150px] hide-label"
            dropdown-class="!max-h-[320px]"
            :label="$t('search.priceFrom')"
            :title="$t('search.noMin')"
            deselectable
            :options="prices"
            type="number"
            name="price-from"
          />
          <AppSelector
            v-model="filters.priceTo"
            class="variant-outline md:min-w-[150px] hide-label"
            dropdown-class="!max-h-[320px]"
            :label="$t('search.priceTo')"
            :title="$t('search.noMax')"
            deselectable
            :options="maxPrices"
            type="number"
            name="price-to"
          />
        </div>
      </div>
    </DefinePriceFilters>
    <DefineBedroomsAndBathroomsFilters>
      <!-- <label
        for="bedrooms"
        class="!block w-full block text-sm font-normal text-neutral pl-2"
      >
        {{ $t('search.bedrooms') }}
      </label> -->
      <!-- <div class="grid grid-cols-2 gap-1.5 mb-1.5">
        <AppSelector
          id="bedrooms"
          v-model="filters.bedroomsFrom"
          class="variant-outline md:min-w-[150px] hide-label"
          dropdown-class="!max-h-[320px]"
          :label="$t('search.bedroomsFrom')"
          :title="$t('search.noMin')"
          deselectable
          :options="bedroomsOptions"
          type="number"
          name="beds-full-from"
        />
        <AppSelector
          v-model="filters.bedroomsTo"
          class="variant-outline md:min-w-[150px] hide-label"
          dropdown-class="!max-h-[320px]"
          :label="$t('search.bedroomsTo')"
          :title="$t('search.noMax')"
          deselectable
          :options="maxBedroomsOptions"
          type="number"
          name="beds-full-to"
        />
      </div> -->
      <label
        for="bathrooms"
        class="!block w-full block text-sm font-normal text-neutral pl-2"
      >
        {{ $t('search.bathrooms') }}
      </label>
      <div class="grid grid-cols-2 gap-1.5 mb-1.5">
        <AppSelector
          id="bathrooms"
          v-model="filters.bathroomsFrom"
          class="variant-outline md:min-w-[150px] hide-label"
          dropdown-class="!max-h-[320px]"
          :label="$t('search.bathroomsFrom')"
          :title="$t('search.noMin')"
          deselectable
          :options="bathsOptions"
          type="number"
          name="baths-full-from"
        />
        <AppSelector
          v-model="filters.bathroomsTo"
          class="variant-outline md:min-w-[150px] hide-label"
          dropdown-class="!max-h-[320px]"
          :label="$t('search.bathroomsTo')"
          :title="$t('search.noMax')"
          deselectable
          :options="maxBathsOptions"
          type="number"
          name="baths-full-to"
        />
      </div>
    </DefineBedroomsAndBathroomsFilters>
    <DefineMoreFilters>
      <div class="flex flex-wrap gap-4 md:flex-col">
        <div class="min-w-[var(--items-width)] flex-1">
          <label for="area" class="block text-sm font-normal text-neutral pl-2">
            {{ $t('search.area') }}
          </label>
          <div class="grid grid-cols-2 gap-1.5 mb-1.5">
            <AppSelector
              id="area"
              v-model="filters.areaFrom"
              class="variant-outline md:w-[200px] hide-label"
              dropdown-class="!max-h-[320px]"
              :label="$t('search.areaFrom')"
              :title="$t('search.noMin')"
              deselectable
              :options="areaOptions"
              type="number"
              name="area-from"
            />
            <AppSelector
              v-model="filters.areaTo"
              class="variant-outline md:w-[200px] hide-label"
              dropdown-class="!max-h-[320px]"
              :label="$t('search.areaTo')"
              :title="$t('search.noMax')"
              deselectable
              :options="maxAreas"
              type="number"
              name="area-to"
            />
          </div>
        </div>
      </div>
      <AppSelector
        v-model="filters.view"
        name="view"
        :label="$t('search.view')"
        :placeholder="$t('search.view')"
        class="variant-outline mb-1.5 w-full"
        :options="viewOptionsFromItems"
        deselectable
      />
      <div>
        <label for="cost" class="block text-sm font-normal text-neutral pl-2">
          {{ $t('search.condoCost') }}
        </label>
        <div class="grid grid-cols-2 gap-1.5 mb-1.5">
          <AppSelector
            id="cost"
            v-model="filters.condoCostFrom"
            class="variant-outline md:w-[200px] hide-label"
            dropdown-class="!max-h-[320px]"
            :label="$t('search.condoCostFrom')"
            :title="$t('search.noMin')"
            deselectable
            :options="condoCostOptions"
            type="number"
            name="cost-from"
          />
          <AppSelector
            v-model="filters.condoCostTo"
            class="variant-outline md:w-[200px] hide-label"
            dropdown-class="!max-h-[320px]"
            :label="$t('search.condoCostTo')"
            :title="$t('search.noMax')"
            deselectable
            :options="maxCondoCost"
            type="number"
            name="cost-to"
          />
        </div>
      </div>
    </DefineMoreFilters>
    <div class="flex flex-wrap items-center my-2 gap-1 max-md:flex-col">
      <h2 class="font-bold text-[18px] sm:text-lg md:text-xl md:mr-auto">
        {{ tableTitle }}
      </h2>
      <AppOptionsSwitch
        v-model="filters.buyType"
        :options="[
          { text: $t('search.buyTypeOptions.used'), value: 'RES' },
          { text: $t('search.buyTypeOptions.rent'), value: 'RNT' }
        ]"
        name="buy-type"
        class="variant-search"
      />
    </div>
    <div class="flex gap-2 mt-2 mb-3 bg-blue-dark py-2 px-4 rounded-md">
      <AppCheckboxGroup
        v-model="filters.bedrooms"
        :options="[
          { text: 'Studio', value: '0' },
          { text: '1 BR', value: '1' },
          { text: '2 BR', value: '2' },
          { text: '3+ BR', value: '3+' }
        ]"
        class="flex gap-2"
      />
      <div
        class="w-[1px] h-[40px] bg-white opacity-50 ml-2 max-md:hidden"
      ></div>
      <div class="relative h-[36px] md:h-[42px] max-md:hidden">
        <AppPopover
          ref="filtersPopover"
          class="left-0 w-max p-4 flex flex-col items-start overflow-visible"
          container-class="inline-block"
          name="filters-popover"
          close-on-scroll
        >
          <AppButton
            class="variant-generic-invisible text-white projects-table-button max-md:hidden"
            :class="{
              'active-filter':
                filters.priceFrom ||
                filters.priceTo ||
                filters.bathroomsFrom ||
                filters.bathroomsTo ||
                filters.areaFrom ||
                filters.areaTo ||
                filters.view ||
                filters.condoCostFrom ||
                filters.condoCostTo
            }"
          >
            <span class="mr-auto">{{ filtersButtonText }}</span>
            <Icon :path="mdiChevronDown" />
          </AppButton>
          <template #panel>
            <div class="flex flex-col w-full">
              <PriceFilters />
              <BedroomsAndBathroomsFilters />
              <MoreFilters />
            </div>
            <AppButton
              class="px-3 py-2 ml-auto mt-1 -mb-1 z-[1] rounded"
              @click="() => closeDropdown(filtersPopover)"
            >
              {{ $t('common.done') }}
            </AppButton>
          </template>
        </AppPopover>
      </div>
      <div class="relative h-[36px] md:h-[42px] md:hidden">
        <AppButton
          class="variant-generic-invisible text-white projects-table-button md:hidden"
          :class="{
            'active-filter':
              filters.priceFrom ||
              filters.priceTo ||
              filters.bathroomsFrom ||
              filters.bathroomsTo ||
              filters.areaFrom ||
              filters.areaTo ||
              filters.view ||
              filters.condoCostFrom ||
              filters.condoCostTo
          }"
          @click="filtersMenu = true"
        >
          <Icon :path="mdiFilter" class="!transform-none" />
        </AppButton>
      </div>
      <div
        v-if="filtersMenu"
        class="bg-white fixed left-0 top-0 z-[61] h-[100lvh] w-full overflow-y-auto"
      >
        <div
          class="flex relative h-[60px] w-full justify-between items-center border-b border-line-light"
        >
          <h2
            class="text-base min-[400px]:text-lg w-full text-center font-semibold"
          >
            {{ resultTitle || $t('search.filters') }}
          </h2>
          <AppButton
            class="icon-button variant-invisible !absolute right-0 top-0 !p-0 h-full aspect-square text-neutral"
            :icon="mdiClose"
            :aria-label="$t('search.closeFilters')"
            @click="filtersMenu = false"
          />
        </div>
        <div
          id="filters-container"
          class="flex flex-col w-full p-4 overflow-y-auto max-h-[calc(100svh-60px)]"
        >
          <PriceFilters />
          <BedroomsAndBathroomsFilters />
          <MoreFilters />
          <AppButton
            class="px-3 py-2 ml-auto mt-1 -mb-1 z-[1] rounded"
            @click="() => (filtersMenu = false)"
          >
            {{ $t('common.done') }}
          </AppButton>
        </div>
      </div>
      <div
        v-if="props.projectFilter.status === 'closed'"
        class="relative h-[36px] md:h-[42px]"
      >
        <AppSelector
          v-model="filters.timeRange"
          class="variant-generic-invisible text-white projects-table-button"
          :options="[
            { text: $t('search.lastNMonths', [3]), value: 3 },
            { text: $t('search.lastNMonths', [6]), value: 6 },
            { text: $t('search.lastNMonths', [12]), value: 12 },
            { text: $t('search.lastNMonths', [24]), value: 24 }
          ]"
          :title="$t('search.timeRange')"
          deselectable
        />
      </div>
      <div
        class="w-[1px] h-[40px] bg-white opacity-50 ml-auto max-md:hidden"
      ></div>
      <AppSelector
        v-model="sortOption"
        class="variant-generic-invisible text-white -mx-2 projects-table-button max-md:hide-label max-md:ml-auto"
        container-class="min-w-[36px]"
        :title="t('search.sortBy')"
        :show-value="false"
        name="sort-table"
        :options="[
          {
            value: 'unitNumber:asc',
            text: t('search.tableSortOptions.unitNumberAsc')
          },
          {
            value: 'unitNumber:desc',
            text: t('search.tableSortOptions.unitNumberDesc')
          },
          {
            value: 'listPrice:asc',
            text: t('search.tableSortOptions.priceLowHigh')
          },
          {
            value: 'listPrice:desc',
            text: t('search.tableSortOptions.priceHighLow')
          },
          {
            value: 'bedrooms:asc',
            text: t('search.tableSortOptions.bedroomsLowHigh')
          },
          {
            value: 'bedrooms:desc',
            text: t('search.tableSortOptions.bedroomsHighLow')
          },
          {
            value: 'bathrooms:asc',
            text: t('search.tableSortOptions.bathroomsLowHigh')
          },
          {
            value: 'bathrooms:desc',
            text: t('search.tableSortOptions.bathroomsHighLow')
          },
          {
            value: 'propertyArea:asc',
            text: t('search.tableSortOptions.areaLowHigh')
          },
          {
            value: 'propertyArea:desc',
            text: t('search.tableSortOptions.areaHighLow')
          },
          {
            value: 'listDate:desc',
            text: t('search.tableSortOptions.dateNewOld')
          },
          {
            value: 'listDate:asc',
            text: t('search.tableSortOptions.dateOldNew')
          }
        ]"
        :placeholder="t('search.sortBy')"
      >
        <template #chevron-icon>
          <Icon :path="mdiSort" class="!min-w-5 !w-5 !h-5 md:ml-2" />
        </template>
      </AppSelector>
    </div>
    <div class="min-h-[400px]">
      <AppTable
        :key="
          (
            'table-' +
            filters.buyType +
            rows?.map(row => row.unitNumber).join('-')
          ).substring(0, 50) + filters.timeRange || 0
        "
        v-model:sort="sort"
        class="mb-4 max-md:max-h-[calc(90svh-132px)]"
        :header="header"
        container-class="table-container max-h-[calc(85svh-132px)]"
        header-items-class="uppercase md:min-w-[86px] bg-white !py-0 text-neutral text-xs"
        :values="filteredRows"
        items-class="whitespace-nowrap"
        sortable
      />
      <h3 v-if="tableSummary" class="my-3" v-html="tableSummary"></h3>
      <div
        v-else
        class="h-4 my-3 mb-4 w-full max-w-[800px] rounded-sm bg-gray-lighter animate-pulse"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { mdiChevronDown, mdiClose, mdiFilter, mdiSort } from '@mdi/js';
import { createReusableTemplate } from '@vueuse/core';
import { FocusTrap } from 'focus-trap-vue';

import type {
  PropertyDocumentResponse,
  QueryResponse
} from '@/types/properties';
import {
  getBedroomsAndBathroomsButtonText,
  getPriceButtonText,
  getRangeButtonText
} from '~/helpers/search';
import { getPropertyLink } from '~/helpers/sitemaps';

const AppPopover = defineAsyncComponent(
  () => import('@/async-components/App/Popover.vue')
);
const AppSelector = defineAsyncComponent(
  () => import('@/async-components/App/Selector.vue')
);
const AppTable = defineAsyncComponent(
  () => import('@/async-components/App/Table.vue')
);
const AppOptionsSwitch = defineAsyncComponent(
  () => import('@/async-components/App/OptionsSwitch.vue')
);
const AppCheckboxGroup = defineAsyncComponent(
  () => import('@/async-components/App/CheckboxGroup.vue')
);

const [DefinePriceFilters, PriceFilters] = createReusableTemplate();
const [DefineBedroomsAndBathroomsFilters, BedroomsAndBathroomsFilters] =
  createReusableTemplate();
const [DefineMoreFilters, MoreFilters] = createReusableTemplate();

const filtersPopover = ref<{ close: () => void } | null>(null);

function closeDropdown(popover: { close: () => void } | null) {
  if (popover) {
    popover.close();
  }
}

function formatDate(date: string | number | Date) {
  if (!date) return null;
  const d = new Date(typeof date === 'number' ? date * 1000 : +date);
  if (d instanceof Date && !isNaN(d)) {
    return d.toLocaleDateString();
  }
  return date;
}

function formatCurrency(value: unknown) {
  if (typeof value !== 'number') {
    value = isNaN(+value) ? value : +value;
  }
  if (typeof value === 'number') {
    return n(value, 'currency', language.value);
  }
  return value;
}

const header = computed(() => [
  {
    key: 'unitNumber',
    label: t('project.unitNumberShort'),
    class: '!bg-neutral-light text-white group-hover:!bg-blue-light'
  },
  { key: 'listPrice', label: t('project.listPrice'), format: formatCurrency },
  { key: 'bedrooms', label: t('property.bedrooms') },
  { key: 'bathrooms', label: t('property.bathrooms') },
  {
    key: 'propertyArea',
    label: t('project.SQFT'),
    format: v => t('search.nAreaShort', [v])
  },
  {
    key: 'propertyAreaM2',
    label: 'M²',
    format: v => t('search.nAreaM2', [v])
  },
  {
    key: 'priceSqft',
    label: t('project.priceSQFTShort'),
    format: formatCurrency
  },
  {
    key: 'maintenanceExpense',
    label: t('project.maintenanceExpenseShort'),
    format: formatCurrency
  },
  {
    key:
      props.projectFilter.status === 'pending'
        ? 'pendingTimestamp'
        : props.projectFilter.status === 'closed'
        ? 'closeDate'
        : 'statusChangeTimestamp',
    label:
      props.projectFilter.status !== 'closed'
        ? t('project.listDate')
        : t('project.closedDate'),
    format: formatDate
  }
]);

const {
  public: { apiUrl }
} = useRuntimeConfig();

const { get } = useHttpMethods();

const { t, n, locale } = useI18n();

const { language } = useLanguage();

const localePath = useLocalePath();

const {
  areaOptions,
  buyTypeOptions,
  condoCostOptions,
  rentPrices,
  buyPrices,
  createSearchParams
} = useSearch();

const props = defineProps({
  projectFilter: {
    type: Object,
    required: true
  },
  projectName: {
    type: String,
    required: true
  }
});

const prices = computed(() => {
  return filters.value.buyType === 'RNT' ? rentPrices : buyPrices;
});

const maxPrices = computed(() => {
  const prices = filters.value.buyType === 'RNT' ? rentPrices : buyPrices;

  return prices.filter(
    price => !filters.value.priceFrom || price.value >= filters.value.priceFrom
  );
});

const bedroomsOptions = Array.from({ length: 5 }, (_, i) => i + 1).map(i => ({
  text: i.toString(),
  value: i
}));

const maxBedroomsOptions = computed(() => {
  return bedroomsOptions.filter(
    option =>
      !filters.value.bedroomsFrom || option.value >= filters.value.bedroomsFrom
  );
});

const bathsOptions = Array.from({ length: 5 }, (_, i) => i + 1).map(i => ({
  text: i.toString(),
  value: i
}));

const maxBathsOptions = computed(() => {
  return bathsOptions.filter(
    bath =>
      !filters.value.bathroomsFrom || bath.value >= filters.value.bathroomsFrom
  );
});

const maxAreas = computed(() => {
  return areaOptions.filter(
    area => !filters.value.areaFrom || area.value >= filters.value.areaFrom
  );
});

const maxCondoCost = computed(() => {
  return condoCostOptions.filter(
    cost =>
      !filters.value.condoCostFrom || cost.value >= filters.value.condoCostFrom
  );
});

const filtersButtonText = computed(() => {
  const textList = [];

  // Price text
  const priceText = getPriceButtonText(filters.value, locale.value);
  if (priceText) textList.push(priceText);

  // Bedrooms & Bathrooms text (Bedrooms are not passed because they are being filtered by the bedrooms property)
  const bedroomsBathroomsText = getBedroomsAndBathroomsButtonText(
    filters.value,
    t
  );
  if (bedroomsBathroomsText) textList.push(bedroomsBathroomsText);

  // Area text
  const areaString = getRangeButtonText(
    {
      from: filters.value.areaFrom,
      to: filters.value.areaTo
    },
    locale.value
  );
  if (areaString) textList.push(areaString + ' sqft');

  // Condo cost text
  const condoCostString = getPriceButtonText(
    {
      priceFrom: filters.value.condoCostFrom,
      priceTo: filters.value.condoCostTo
    },
    locale.value
  );
  if (condoCostString) textList.push(`cc: ${condoCostString}`);

  // View
  if (filters.value.view) textList.push(filters.value.view);

  return (
    (textList.length && textList.length <= 3 && textList.join(', ')) ||
    t('search.filters')
  );
});

const filters = ref<{
  buyType: 'RES' | 'RNT';
  bedrooms: number[];
  priceFrom?: number;
  priceTo?: number;
  bedroomsFrom?: number;
  bedroomsTo?: number;
  bathroomsFrom?: number;
  bathroomsTo?: number;
  areaFrom?: number;
  areaTo?: number;
  view?: string;
  condoCostFrom?: number;
  condoCostTo?: number;
  timeRange?: number;
}>({
  buyType: 'RES',
  bedrooms: []
});

const filtersMenu = ref(false);

const resultTitle = computed(() => {
  if (!items.value) {
    return '';
  } else if (!items.value.length) {
    return t('common.noResults');
  } else {
    return t('search.nResults', [
      Intl.NumberFormat(language.value).format(items.value.length)
    ]);
  }
});

function resetFilters(keys: (keyof typeof filters.value)[]) {
  if (!keys?.length) {
    filters.value = {
      buyType: 'RES'
    };
  } else {
    keys.forEach(s => {
      filters.value = {
        ...filters.value,
        [s]: undefined
      };
    });
  }
}

async function fetchValues() {
  const queryParams = createSearchParams({
    ...filters.value,
    ...props.projectFilter,
    excludeFields: 'photos,geopoint,snippet',
    unit: '*',
    perPage: 250,
    bedrooms: filters.value.bedrooms.length
      ? filters.value.bedrooms.map(String)
      : undefined
  });

  const url = apiUrl + '/search/?' + new URLSearchParams(queryParams);

  const propertiesResponse = (
    await get<{ data: QueryResponse<PropertyDocumentResponse> }>(url)
  ).data;

  return propertiesResponse?.hits.map(hit => hit.document) || [];
}

watch(
  filters,
  async () => {
    if (filters.value.priceFrom || filters.value.priceTo) {
      if (
        filters.value.priceFrom &&
        !prices.value.find(p => p.value === filters.value.priceFrom)
      ) {
        filters.value = {
          ...filters.value,
          priceFrom: undefined
        };
        return;
      }
      if (
        filters.value.priceTo &&
        !prices.value.find(p => p.value === filters.value.priceTo)
      ) {
        filters.value = {
          ...filters.value,
          priceTo: undefined
        };
        return;
      }
    }

    console.log('updating items.value from filters');
    items.value = await fetchValues();
  },
  { deep: true }
);

const items = ref<PropertyDocumentResponse[] | null>(null);

interface PropertyDocumentResponseExtended extends PropertyDocumentResponse {
  propertyAreaM2: number;
  priceSqft: number | null;
  link: string;
}

const rows = computed<PropertyDocumentResponseExtended[] | null>(() => {
  console.log('updating rows.value');
  return items.value?.map((item: PropertyDocumentResponse) => {
    let unitNumber: string | number = +(item.unitNumber || '');

    if (isNaN(unitNumber)) {
      unitNumber = item.unitNumber;
    }

    if (!unitNumber) {
      const match = item.full.match(/# ?(\d+)/);

      if (match) {
        unitNumber = +match[1];
      }
    }

    // TODO: Remove this fix when the backend is fixed

    if (
      typeof item.closeDate === 'string' &&
      item.closeDate &&
      item.closeDate.includes('-')
    ) {
      const [year, month, day] = item.closeDate.split('-').map(Number);
      item.closeDate = new Date(year, month - 1, day);
    }

    return {
      ...item,
      propertyAreaM2: +(item.propertyArea * 0.092903).toFixed(0),
      priceSqft: item.propertyArea
        ? +(item.listPrice / item.propertyArea).toFixed(0)
        : null,
      unitNumber: unitNumber || item.unitNumber,
      link: localePath(`/${t('routes.properties')}/${getPropertyLink(item, t)}`)
    };
  });
});

const filteredRows = computed(() => {
  if (!filters.value.timeRange) {
    return rows.value;
  }

  const timeColumn =
    props.projectFilter.status === 'pending'
      ? 'pendingTimestamp'
      : props.projectFilter.status === 'closed'
      ? 'closeDate'
      : 'statusChangeTimestamp';

  const months = filters.value.timeRange;
  const now = new Date().getTime();
  const monthsAgo = now - 1000 * 60 * 60 * 24 * 30 * months;

  return rows.value?.filter(row => {
    const rawTime = row[timeColumn];
    let timeMs: number;

    if (rawTime instanceof Date) {
      timeMs = rawTime.getTime();
    } else if (typeof rawTime === 'number') {
      // Convert seconds to milliseconds if timestamp is in seconds
      timeMs = rawTime * (rawTime < 1e12 ? 1000 : 1);
    } else {
      console.warn('Invalid time value:', rawTime);
      return true; // Include rows with invalid dates
    }

    console.log(
      'Row:',
      row.unitNumber,
      '\nColumn:',
      timeColumn,
      '\nTime:',
      new Date(timeMs).toISOString(),
      '\nMonths ago:',
      new Date(monthsAgo).toISOString(),
      '\nMonths:',
      months,
      '\nIncluded:',
      timeMs >= monthsAgo
    );

    return timeMs >= monthsAgo;
  });
});

const tableTitle = computed(() => {
  if (filters.value.buyType === 'RNT') {
    if (props.projectFilter.status === 'active') {
      return t('project.availableCondosForRent');
    } else if (props.projectFilter.status === 'pending') {
      return t('project.pendingCondosForRent');
    } else if (props.projectFilter.status === 'closed') {
      return t('project.closedCondosForRent');
    }
  } else if (props.projectFilter.status === 'active') {
    return t('project.availableCondosForSale');
  } else if (props.projectFilter.status === 'pending') {
    return t('project.pendingCondosForSale');
  } else if (props.projectFilter.status === 'closed') {
    return t('project.closedCondosForSale');
  }
});

const tableSummary = computed(() => {
  const project = `<strong>${props.projectName}</strong>`;
  const averagePriceSqft = rows.value?.length
    ? rows.value.reduce((acc, row) => acc + (row.priceSqft || 0), 0) /
      rows.value.length
    : 0;

  const averagePriceSqftString = averagePriceSqft
    ? `<strong>${n(averagePriceSqft, 'currency')}</strong>`
    : '';

  if (!rows.value) {
    return '';
  } else if (!rows.value.length) {
    return t('project.noCondos', { project });
  } else {
    return t('project.condos', {
      project,
      n: Intl.NumberFormat(language.value).format(rows.value.length),
      price: averagePriceSqftString
    });
  }
});

let views = new Set<string>();

const viewOptionsFromItems = computed(() => {
  rows.value?.forEach(row => {
    row.view.forEach(view => views.add(view));
  });

  const newViews = Array.from(views).map(view => ({
    text: view,
    value: view
  }));

  newViews.sort((a, b) => a.text.localeCompare(b.text));

  views = new Set(newViews.map(view => view.text));

  return newViews.length ? newViews : [{ text: 'No views', value: '' }];
});

onMounted(() => {
  console.log('updating items.value from mounted');
  fetchValues().then(response => {
    items.value = response;
  });
});

const sortOption = ref('unitNumber:asc');

const sort = computed({
  get: () => {
    if (!sortOption.value) return { column: '', sort: 'asc' };
    const [column, sort] = sortOption.value.split(':');
    return { column, sort: sort as 'asc' | 'desc' };
  },
  set: value => {
    sortOption.value = `${value.column}:${value.sort}`;
  }
});
</script>

<style scoped lang="scss">
.projects-table-button {
  :global(.selector-buttonIcon) {
    @apply text-white #{!important};
  }
  &.app--button,
  & > :global(.selector-button) {
    @apply rounded text-sm h-[36px] md:h-[42px] pl-2 md:pl-2 pr-0.5 md:pr-1 font-bold;
    // with aira-expanded="true"
  }
  &.app--button {
    &[aria-expanded='true'],
    &[data-popper-shown],
    .popover-active &,
    &.popover-active {
      .mdi-icon {
        @apply rotate-180;
      }
    }
  }
}

.active-filter-on-selected.option-selected,
.active-filter {
  @apply relative;
  &::after {
    content: '';
    @apply absolute -top-1 -right-1 w-3 h-3 rounded-full bg-primary;
  }
}
</style>
